import React, { useState, useCallback } from "react";

const TraceabilityModal = ({ t, traceDetail, traceData }) => {
  console.log(traceDetail, traceData, "123456");
  return (
    <div
      className="modal fade modal1-width"
      id="TraceabilityModal"
      tabIndex={-1}
      aria-labelledby="TraceabilityModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-right">
        <div className="modal-content modal1-border modal-top-div">
          <div className="heading-div">
            <h4 className="heading-div-head">{t("Traceability Origin")}</h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body-border"></div>
          <div className="modal-body-first-div">
            <div className="img-div">
              <img
                className="img1"
                src={
                  traceDetail?.image ||
                  "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png"
                }
                alt="product-image"
                onError={(e) => {
                  e.target.onerror = null; // prevent infinite loop
                  e.target.src = "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                }}
              />
            </div>
            <div className="trace-info">
              <h6 className="trace-title">
                {traceDetail?.name || "Product Name"}
              </h6>
              <div className="trace-SKU trace-SKU-subtext mb-1">
                {traceDetail?.SKU || "-"}
              </div>
              <div className="trace-SKU trace-SKU-subtext mb-1">
                {traceDetail?.stock_id || "-"}
              </div>
              <div className="trace-transactionId-div">
                <div className="trace-subtext d-flex" style={{ gap: "0.2vw" }}>
                  <span className="trace-label">Transaction ID:</span>{" "}
                  <span className="trace-label-value truncate-transactionId">
                    {traceDetail?.transactionId || "-"}
                  </span>
                </div>
                <p className="trace-subtext">
                  <span className="trace-label">Quantity:</span>{" "}
                  <span className="trace-label-value">
                    {traceDetail?.pos_Qty || 0}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="traceability-timeline">
            {traceData && traceData.length > 0 ? (
              traceData.map((trace, index) => (
                <div key={trace.id || index} className="timeline-item">
                  <div className="timeline-icon-wrapper">
                    <div className="timeline-icon">
                      <img src={trace.iconName?.icon} alt={trace.name} />
                    </div>
                    {index < traceData.length - 1 && (
                      <div className="timeline-connector"></div>
                    )}
                  </div>
                  <div className="timeline-content">
                    <h6 className="timeline-title" style={{ color: trace?.iconName?.color ? trace?.iconName?.color : "#606060" }}>{trace.name}</h6>
                    <div className="timeline-details">
                      {trace.countries && trace.countries.length > 0 ? (
                        <span className="timeline-country" style={{ color: trace?.iconName?.color ? trace?.iconName?.color : "#606060" }}>
                          {trace.countries.map(c => c.label).join(", ")}
                        </span>
                      ) : null}
                      {trace.transactionId && trace.transactionId !== "-" && (
                        <span className="timeline-date">
                          {trace.dateTime}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-trace-data">
                <p>No traceability data available</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TraceabilityModal;
